var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"call-us-link",attrs:{"href":_vm.tellNo},on:{"click":_vm.callUs}},[_vm._v(_vm._s(_vm.$t('message.callUs')))])}
var staticRenderFns = []

export { render, staticRenderFns }